import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const Credibility = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#141414] border-b hairline-dark" data-testid="credibility-strip">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {t.CREDIBILITY.map((item, i) => (
          <Reveal key={item} delay={i * 0.08} y={20}>
            <div
              className={`flex items-center gap-4 py-3 ${i > 0 ? "lg:border-s hairline-dark lg:ps-8" : ""}`}
              data-testid={`credibility-item-${i + 1}`}
            >
              <span className="h-1.5 w-1.5 rotate-45 bg-champagne shrink-0" aria-hidden="true" />
              <span className="text-[0.7rem] uppercase tracking-[0.2em] text-ivory/65 leading-relaxed">{item}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Credibility;
